import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { downloadFile, getLongDate, getStringDate } from 'src/app/common/util';
import { AccountLevel4Response } from 'src/app/models/account.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AccountService } from 'src/app/services/account.service';
import { SpendingReportService } from 'src/app/services/reports/spending-report.service';

@Component({
  selector: 'app-spending-report',
  templateUrl: './spending-report.component.html',
  styleUrls: ['./spending-report.component.scss']
})
export class SpendingReportComponent {
  selectedReport = 0;
  startDate = "";
  endDate = "";
  inputs = {
    account: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: '',
      color: '',
      tooltip: 'status-warehouse',
      data: {
        id: null
      }
    }
  }

  accountSelected: AccountLevel4Response = null;
  filterAccounts: AccountLevel4Response[] = [];
  filterAccountsExpenses: AccountLevel4Response[] = [];
  accounts: AccountLevel4Response[] = [];
  firstMonth = 0;
  secondMonth = 1;
  year = 2015;
  years = [2015];

  firstMonth2 = 0;
  secondMonth2 = 1;
  year2 = 2025;

  constructor(
    private toastService: ToastrService,
    private accService: AccountService,
    private spendingReport: SpendingReportService
  ) {
    const today = new Date();
    this.endDate = getStringDate(today);
    today.setDate(today.getDate() - 30);
    this.startDate = getStringDate(today);
    this.year = parseInt(this.endDate.split('-')[0]);
    for (let i = 0; i < this.year - this.years[0]; i++) {
      this.years.push(2015 + i + 1);
    }
  }
  timeout = null;
  writeAccount(event: any) {
    const inputField = event.target as HTMLInputElement;
    const inputValue = inputField.value as any;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.filterAccounts = this.accounts.filter((acc) => {
        return (acc.displayId + " " + acc.name).toLowerCase().includes(inputValue);
      });
      if (this.filterAccounts.length == 1) {
        this.selectAccount(this.filterAccounts[0]);
      } else {
        if (this.inputs.account.required) {
          this.inputs.account.class = "fa-asterisk";
        } else {
          this.inputs.account.class = "";
        }
        this.inputs.account.verified = false;
        this.accountSelected = null;
      }
    }, 500);
  }
   writeAccountExpense(event: any) {
    const inputField = event.target as HTMLInputElement;
    const inputValue = inputField.value as any;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.filterAccountsExpenses = this.accounts.filter((acc) => {
        return (acc.displayId + " " + acc.name).toLowerCase().includes(inputValue);
      });
      if (this.filterAccountsExpenses.length == 1) {
        this.selectAccount(this.filterAccountsExpenses[0]);
      } else {
        if (this.inputs.account.required) {
          this.inputs.account.class = "fa-asterisk";
        } else {
          this.inputs.account.class = "";
        }
        this.inputs.account.verified = false;
        this.accountSelected = null;
      }
    }, 500);
  }

  selectAccount(acc: any) {
    clearTimeout(this.timeout);
    this.inputs.account.class = "fa-check";
    this.inputs.account.verified = true;
    this.inputs.account.value = acc.displayId + " - " + acc.name;
    this.accountSelected = acc;
  }

  getSpendingReport(type: string) {
    const accountIdSelected = this.accountSelected == null ? null : this.accountSelected.id;
    this.spendingReport.getSpendingReport(accountIdSelected, getLongDate(this.startDate), getLongDate(this.endDate), type).subscribe({
      next: (response: ResponseObject) => {
        if (type == 'json') {
          //logica para mostrar
        } else {
          downloadFile(response.data, type, 'Integración por Categorías y Reportería ' + this.startDate + " - " + this.endDate);
          this.toastService.success("Se ha descargado correctamente el reporte de Integración por Categorías y Reportería");
        }
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener el reporte de Integración por Categorías y Reportería");
      }
    })
  }

  getSpendingReport2(type: string) {
    const secondMonthInt2 = parseInt(this.secondMonth2 as any, 10);
    const firstDate = new Date(this.year2, this.firstMonth2, 1).getTime();
    const lastDate = new Date(this.year2, secondMonthInt2 + 1, 0).getTime();
    const accountIdSelected = this.accountSelected == null ? null : this.accountSelected.id;
    this.spendingReport.getSpendingReport2(accountIdSelected, firstDate, lastDate, type).subscribe({
      next: (response: ResponseObject) => {
        if (type == 'json') {
          //logica para mostrar
        } else {
          downloadFile(response.data, type, 'Control de Gastos y Reportería');
          this.toastService.success("Se ha descargado correctamente el reporte de Control de Gastos y Reportería");
        }
      },
      error: (error: HttpErrorResponse) => {
        if (error.status == 400) {
          this.toastService.error(error.error.message);
        } else {
          this.toastService.error("Error al obtener el reporte de Control de Gastos y Reportería");
        }
      }
    })
  }

  getSpendingReport3(type: string) {
    const secondMonthInt2 = parseInt(this.secondMonth as any, 10);
    var firstDate = (new Date(this.year, this.firstMonth, 1)).getTime();
    var lastDate = (new Date(this.year, secondMonthInt2 + 1, 0)).getTime();
    const accountIdSelected = this.accountSelected == null ? null : this.accountSelected.id;
    this.spendingReport.getSpendingReport3(accountIdSelected, firstDate, lastDate, type).subscribe({
      next: (response: ResponseObject) => {
        if (type == 'json') {
          //logica para mostrar
        } else {
          downloadFile(response.data, type, 'Control de Gastos y Reportería');
          this.toastService.success("Se ha descargado correctamente el reporte de Control de Gastos y Reportería");
        }
      },
      error: (error: HttpErrorResponse) => {
        if (error.status == 400) {
          this.toastService.error(error.error.message);
        } else {
          this.toastService.error("Error al obtener el reporte de Control de Gastos y Reportería");
        }
      }
    })
  }

  showReport(report: number) {
    this.selectedReport = this.selectedReport == report ? 0 : report;
    this.accountSelected = null;
    this.inputs.account.class ="";
    this.inputs.account.value = "";
    this.inputs.account.verified = false;
    switch (report) {
      case 3:
      case 1: {
        this.filterAccounts = [];
        this.accountSelected = null;
        this.accService.getAccountsLevel4().subscribe({
          next: (response: ResponseObject) => {
            this.accounts = response.data;
            for (let i = 0; i < this.accounts.length && i < 5; i++) {
              const element = this.accounts[i];
              this.filterAccounts.push(element);
            }
          },
          error: (error: any) => {
            this.toastService.error("Error al obtener las cuentas");
          }
        })
        break;
      }
      case 2: {
        this.filterAccountsExpenses = [];
        this.accountSelected = null;
        this.accService.getAccountsLevel3().subscribe({
          next: (response: ResponseObject) => {
            this.accounts = response.data.filter(acc => acc.id >= 40 && acc.id <= 61);
            for (let i = 0; i < this.accounts.length && i < 5; i++) {
              const element = this.accounts[i];
              this.filterAccountsExpenses.push(element);
            }
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error("Error al obtener las cuentas");
          }
        });
        break;
      }
      default: {
        this.toastService.error("Error al cargar reporte");
      }
    }
  }
}
